/** Search param key for /activation deep links (value is removed after handling). */
export const ACTIVATION_ENTRY_SEARCH_PARAM = "flow";

/**
 * Values for `?flow=` when landing on /activation from other apps or marketing.
 * Sync these strings with any external repo that links here.
 */
export const ActivationEntryType = {
  /** Mobile plan service: preloaded SIM / SIM-card activation upsell path on `/activation`. */
  PreloadedSim: "preloaded-sim",
  /** Fixed-line: activate a reseller-purchased phone base (activation code flow). */
  FixedPhoneBase: "fixed-phone-base",
} as const;
